import React, { useEffect, useState } from "react";
import "./Featured.scss";
import Product from "../Product/Product";
import { client } from "../../../lib/client";

const Featured = ({ innerPage, headingText }) => {
  const [products, setProducts] = useState([]);
  console.log(products[0]?._id);
  useEffect(() => {
    const query = '*[_type == "product"]';

    client.fetch(query).then((data) => {
      setProducts(data);
    });
  }, []);

  return (
    <div className="featured-container">
      {!innerPage && <div className="sec-heading">Popular Items</div>}
      <div className={`featured ${innerPage ? "innerPage" : ""}`}>
        {products
          ?.sort(() => Math.random() - 0.5)
          ?.slice(0, 4)
          ?.map(({ _id, name, brand, description, image, price, slug }) => {
            const productData = {
              _id,
              name,
              brand,
              description,
              image,
              price,
              slug,
            };
            return <Product key={_id} data={productData} />;
          })}
      </div>
    </div>
  );
};

export default Featured;
